import React, { useEffect } from "react";
import { Helmet } from 'react-helmet-async';
import './Home.css';

// Importación de todos tus componentes modulares
import VideoSection from "./VideoSection";
import Proceso from "./Proceso";
import Portfolio from "./Portfolio";
import Carousel from "./Carousel";
import Soluciones from "./Soluciones";
import Blog from "./Blog";
import Demos from "./Demos";
import AboutUs from "./AboutUs";
import Pricing from "./Pricing";
import ContactForm from "./ContactForm";
import FloatingChat from "./FloatingChat";
import CookiesPopup from "./CookiesPopup";

const Home = () => {

    // Efecto global para las animaciones de aparición al hacer scroll
    useEffect(() => {
        const rvEls = document.querySelectorAll('.rv');
        const rvObs = new IntersectionObserver((entries) => {
            entries.forEach(e => {
                if (e.isIntersecting) {
                    e.target.classList.add('in');
                    rvObs.unobserve(e.target);
                }
            });
        }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

        rvEls.forEach(el => rvObs.observe(el));

        return () => rvObs.disconnect(); // Limpiamos el observador al cambiar de página
    }, []);

    return (
        <>
            {/* CONFIGURACIÓN SEO PARA LA HOME */}
            <Helmet>
                <title>NAVI - Tu camino hacia la industria inteligente</title>
                <meta name="description" content="NAVI es una empresa especializada en soluciones logísticas y de automatización usando agentes de Inteligencia Artificial a medida." />

                <meta property="og:title" content="NAVI - Tu camino hacia la industria inteligente" />
                <meta property="og:description" content="Impulsamos la eficiencia de tu empresa con soluciones personalizadas e innovadoras." />
                <meta property="og:image" content="https://www.navitechlabs.com/assets/logo-sin-fondo.webp" />
                <meta property="og:url" content="https://www.navitechlabs.com/" />
                <meta property="og:type" content="website" />
            </Helmet>

            <main className="main-content">
                {/* 1. Hero (Fondo animado Canvas) */}
                <VideoSection />

                {/* 2. Proceso de la empresa */}
                <Proceso />

                {/* 3. Portfolio de casos */}
                <Portfolio />

                {/* 4. Carrusel de Servicios Original */}
                <Carousel />

                {/* 5. Soluciones y Checklists */}
                <Soluciones />

                {/* 6. Artículos de Blog */}
                <Blog />

                {/* 7. Demos Interactivas */}
                <Demos />

                {/* 8. Nosotros (Equipo) */}
                <AboutUs />

                {/* 9. Planes y Comparativa */}
                <Pricing />

                {/* 10. Contacto (Formulario + Webhook N8N) */}
                <ContactForm />

                {/* --- COMPONENTES FLOTANTES GLOBALES --- */}
                <FloatingChat />
                <CookiesPopup />
            </main>
        </>
    );
};

export default Home;
